import React from 'react'
import { FaceProps } from '@vatom/sdk/react'

import WebFace from './Faces/WebFace'

export const VatomFaces: React.FC<FaceProps>[] = [WebFace]
